<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>
              검색 조건
            </h4>
          </md-card-header>
          <md-card-content>
            <table class="flex-table">
              <tr>
                <th>조회 기간</th>
                <td>
                  <div class="inline-flex mb5">
                    <input v-focus type="text" v-model="query.startDate" v-mask="'####-##-##'">
                    <span class="date-txt">부터</span>
                  </div>
                  <div class="inline-flex mb5">
                    <input type="text" v-model="query.endDate" v-mask="'####-##-##'">
                    <span class="date-txt">까지</span>
                  </div>
                  <div class="inline-flex">
                    <button class="btn-sm" @click="onClickPeriodButton(3, 'months')">
                      3개월
                    </button>
                    <button class="btn-sm" @click="onClickPeriodButton(6, 'months')">
                      6개월
                    </button>
                    <button class="btn-sm" @click="onClickPeriodButton(1, 'year')">
                      1년
                    </button>
                    <button class="btn-sm" @click="onClickPeriodButton(2, 'years')">
                      2년
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <th>회비년도</th>
                <td>
                  <input type="text" maxlength="4" v-model="query.feeYear">
                </td>
              </tr>
              <tr>
                <th>회비구분</th>
                <td>
                  <label v-for="item in feeCdList" v-bind:key="item.code"><input type="checkbox" :key="item.code" :value="item.code" v-model="checkedFeeCdList">{{item.codeNm}}</label>
                </td>
              </tr>
            </table>
          </md-card-content>
          <md-card-actions>
            <md-button class="md-info md-sm full-size-button" @click="onClickTab(1)">
              <md-icon>check</md-icon>
              검색
            </md-button>
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">

        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>
              납부 상세 내역
            </h4>
          </md-card-header>
          <div class="md-group tab-area">
            <md-button class="md-default" @click="onClickTab(1)">회비 내역</md-button>
            <md-button class="md-default" @click="onClickTab(2)">개인 납부리스트</md-button>
            <md-button class="md-default" @click="onClickTab(3)">지부/분회 납부리스트</md-button>
            <md-button class="md-default" @click="onClickTab(4)">임원 납부리스트</md-button>
          </div>

          <!--1번 탭-->
          <payment-list-total-comp ref="paymentListTotal" :show-tab.sync="showTab"></payment-list-total-comp>

          <!--2번 탭-->
          <payment-list-private-comp ref="paymentListPrivate" :show-tab.sync="showTab" :query-data.sync="query"></payment-list-private-comp>

          <!--3번 탭-->
          <payment-list-branch-comp ref="paymentListBranch" :show-tab.sync="showTab"></payment-list-branch-comp>

          <!-- 4번 탭-->
          <payment-list-executive-comp ref="paymentListExecutive" :show-tab.sync="showTab" :query-data.sync="query"></payment-list-executive-comp>

        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import moment from "moment";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import PaymentListTotalComp from "@/pages/MembershipFee/Components/PaymentListTotalComp";
import PaymentListPrivateComp from "@/pages/MembershipFee/Components/PaymentListPrivateComp";
import PaymentListBranchComp from "@/pages/MembershipFee/Components/PaymentListBranchComp";
import PaymentListExecutiveComp from "@/pages/MembershipFee/Components/PaymentListExecutiveComp";

export default {
  components: {
    PaymentListTotalComp,
    PaymentListPrivateComp,
    PaymentListBranchComp,
    PaymentListExecutiveComp
  },


  data(){
    return {
      formatter,
      feeCdList : [],
      checkedFeeCdList : ["10","11","12","40"],
      query: {
        feeYear: "",
        startDate: null,
        endDate: null,
        feeCd:"",
        memberorgGb : ""
      },

      showTab: 1
    }
  },

  created() {
    moment.locale();
    this.queryFeeCd();
    this.initQueryDate();
  },

  methods: {
    queryFeeCd() {
      kuaaFnc.fncFeeCdTypes(null,res => {
        this.feeCdList = res.data.data.contents;
      });
    },
    onClickTab(index){
      this.showTab = index;
      switch (index) {
        case 1:
          this.totalQuery();
          break;
        case 2:
          this.privateTotalQuery();
          break;
        case 3:
          this.branchQuery();
          break;
        case 4:
          this.executiveQuery();
          break;
      }
    },

    initQueryDate() {
      let now = moment();
      this.query.endDate = now.format("YYYY-MM-DD");
      // this.query.fromDate = now.subtract(3, "years").format("YYYY-MM-DD");
    },

    onClickPeriodButton(num, type) {
      this.query.startDate = moment().subtract(num, type).format("YYYY-MM-DD");
    },

    parseQuery (query) {
      let params = JSON.parse(JSON.stringify(query));
      params['startDate'] = params['startDate'] && params['startDate'] != '' ? moment(params['startDate']).format("YYYYMMDD") : params['fromDate'];
      params['endDate'] = params['endDate'] && params['endDate'] != '' ? moment(params['endDate']).format("YYYYMMDD") : params['endDate'];
      return params;
    },

    /**
     * 회비내역 실행
     */
    totalQuery() {
      this.query.feeCd = this.checkedFeeCdList;
      this.query.memberorgGb = "";
      this.query.branchGb = "";
      this.query.feeGb = "";
      this.$refs.paymentListTotal.sendQuery(this.parseQuery(this.query));
    },

    /**
     * 개인납부리스트 조회
     */
    privateTotalQuery() {
      this.query.feeCd = this.checkedFeeCdList;
      this.query.memberorgGb = "";
      this.query.branchGb = "";
      this.$refs.paymentListPrivate.sendQuery(this.parseQuery(this.query));
    },

    /**
     * 지부/분회 납부리스트 조회
     */
    branchQuery() {
      this.query.feeCd = this.checkedFeeCdList;
      this.query.memberorgGb = "";
      this.query.branchGb = "Y";
      this.query.feeGb= "";
      this.$refs.paymentListBranch.sendQuery(this.parseQuery(this.query));
    },

    /**
     * 임원 납부리스트 조회
     */
    executiveQuery() {
      this.query.feeCd = "[12]";
      this.query.memberorgGb = "00";
      this.query.branchGb = "";
      this.query.feeGb= "";
      this.$refs.paymentListExecutive.sendQuery(this.parseQuery(this.query));
    }
  }
}
</script>

<style scoped>
  /*.flex-table span.date-txt {margin-top: 20px}*/
</style>